
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34476',
  depVersions: {
  "documents-public-ui": "static-1.34476",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34481",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2125",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5584",
  "hs-test-utils": "static-1.8005",
  "hub-http": "static-1.6214",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11460",
  "I18n": "static-7.1622",
  "jasmine-immutable": "static-1.3013",
  "jasmine-runner": "static-1.6458",
  "lodash": "static-1.3",
  "quartz": "static-1.7020",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16659",
  "reporting-data": "static-1.67502",
  "reporting-testing-lib": "static-1.9435",
  "reporting-visualizations": "static-1.59578",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4755",
  "webpack-env": "static-1.54",
  "atom": "static-1.5062",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2489",
  "classnames": "static-2.10",
  "cssUtils": "static-1.788",
  "customer-data-filters-ui": "static-1.39726",
  "customer-data-objects": "static-1.7658",
  "customer-data-property-utils": "static-1.8080",
  "data-fetching-client": "static-1.9662",
  "enviro": "static-4.446",
  "FireAlarmUi": "static-1.4505",
  "flux-actions": "static-1.337",
  "FormsCommonComponents": "static-1.85815",
  "FormUrlGenerator": "static-2.4709",
  "foundations-components": "static-1.7914",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11767",
  "icons": "static-2.646",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7149",
  "metrics-js": "static-1.9619",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.397",
  "property-description-translator": "static-1.3836",
  "property-translator": "static-1.5391",
  "quartz-config": "static-1.798",
  "quartz-core": "static-1.6239",
  "quick-fetch": "static-1.3909",
  "raven": "static-3.5907",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5337",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8159",
  "reference-resolvers-lite": "static-1.8085",
  "report-customization-components": "static-1.13127",
  "reporting-enablement": "static-1.22885",
  "reporting-reports": "static-1.67180",
  "reporting-snowflake": "static-1.56120",
  "reporting-ui-components": "static-2.64773",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4641",
  "sales-content-partitioning": "static-1.8934",
  "SalesContentIndexUI": "static-3.9224",
  "sanitize": "static-1.4468",
  "sanitize-text": "static-1.8132",
  "self-service-api": "static-1.10239",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1740",
  "signup-constants": "static-1.18818",
  "signup-ui-lego-core": "static-1.20828",
  "signup-ui-url-generator": "static-2.8038",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4754",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10984",
  "ui-addon-i18n": "static-1.11142",
  "ui-addon-react-router-dom": "static-1.9535",
  "ui-addon-upgrades": "static-9.17969",
  "ui-asset-management-lib": "static-1.11009",
  "ui-images": "static-2.1151",
  "UIComponents": "static-3.8406",
  "usage-tracker": "static-1.7334",
  "usage-tracker-container": "static-1.7324",
  "usage-tracker-core": "static-1.7184",
  "usage-tracker-public": "static-1.7145",
  "viral-links-lib": "static-1.7052",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3392",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3297",
  "quartz-webpack": "static-1.3244",
  "ai-components-ui-library": "static-1.8924",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4856",
  "foundations-theming": "static-1.4409",
  "quartz-auth": "static-1.695",
  "ui-business-units-lib": "static-1.9041",
  "usage-tracker-session-replay": "static-1.5020",
  "foundations-theming-base": "static-1.3394",
  "HeadJS": "static-2.758",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3116",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.74",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4319",
  "csstype": "static-1.50",
  "quartz-head": "static-1.685",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7921",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3578",
  "persist-promise": "static-1.3689",
  "quartz-i18n": "static-1.695",
  "reporting-client-types": "static-1.2499",
  "foundations-components-legacy": "static-1.939",
  "hs-story-utils": "static-1.9418",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9939",
  "hubspotter-http": "static-1.4644",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.208",
  "conversations-skeleton-state": "static-1.7238",
  "crm-message-bus": "static-1.42958",
  "customer-data-filters-ui-msw-helpers": "static-1.22161",
  "customer-data-objects-ui-components": "static-1.13017",
  "customer-data-reference-ui-components": "static-1.13153",
  "customer-data-ui-utilities": "static-1.9817",
  "framework-builder-read-service-client": "static-1.3997",
  "framework-data-schema-quick-fetch": "static-1.6779",
  "framework-data-schema-resolvers": "static-1.6874",
  "inbound-db-properties-service-client": "static-1.3839",
  "multi-account-reference-resolvers": "static-1.971",
  "onboarding-tours": "static-1.16575",
  "reporting-datasets-permissions-lib": "static-1.13649",
  "ui-addon-teams": "static-1.21529",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68326",
  "customer-data-properties": "static-1.51504",
  "forms-ai-lib": "static-1.4304",
  "forms-utils-lib": "static-1.12559",
  "foundations-components-test-utils": "static-1.5397",
  "react-dnd-compat": "static-1.4608",
  "react-tinymce": "static-1.55210",
  "tinymce-config": "static-2.54336",
  "ui-gdpr-components": "static-1.10340",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4183",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.20",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1887",
  "ui-fonts": "static-1.722",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.831",
  "mobile-manifest-mixins": "static-1.533",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.450",
  "quartz-test": "static-1.695",
  "quartz-tracking": "static-1.399",
  "batch-promise": "static-1.1532",
  "external-options-client-types": "static-1.4151",
  "react-colorpicker": "static-2.10200",
  "ui-addon-draggable-compat": "static-2.4247",
  "copilot-toolkit": "static-1.11106",
  "data-quality-ui-library": "static-1.12991",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6452",
  "reporting-action-components": "static-1.41270",
  "reporting-filters": "static-1.295",
  "reporting-insights-lib": "static-1.1716",
  "reporting-plugins": "static-1.10308",
  "ui-addon-opt": "static-4.8360",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25347",
  "hubspot-apollo-client": "static-1.4869",
  "bend-plugin-chirp-manifest": "static-1.51",
  "chirp-fetch": "static-1.1878",
  "sales-templates-service-types-lib": "static-1.4162",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5863",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4073",
  "nested-table": "static-1.217",
  "timezone-utils": "static-2.5235",
  "bender-build-tools": "static-1.3199",
  "chatspot-core": "static-1.21246",
  "bend-plugin-foundations-theming": "static-1.2892",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9937",
  "hs-resources": "static-1.147",
  "pulse": "static-1.564",
  "restore-request-side-panel-lib": "static-1.858",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3790",
  "crm-pipelines-api-client-types": "static-1.4130",
  "multi-currency-client-types": "static-1.3684",
  "getting-started-shared-tasks": "static-1.18465",
  "growth-data-modal": "static-1.5414",
  "growth-onboarding-confetti": "static-1.3058",
  "growth-onboarding-next-action-utils": "static-1.1892",
  "navigation-components": "static-1.17998",
  "onboarding-tours-client": "static-1.4789",
  "onboarding-tours-utils": "static-1.641",
  "ui-shepherd-react": "static-3.10152",
  "ui-shepherd-tracker": "static-1.7533",
  "ui-universal-auth": "static-1.8966",
  "user-context": "static-1.5095",
  "cms-field-types": "static-1.4802",
  "content-icons-ui": "static-1.2223",
  "integrations-lib": "static-1.16092",
  "calling-global-api": "static-1.64478",
  "calling-internal-common": "static-1.31292",
  "calling-lifecycle-internal": "static-1.65860",
  "calling-lifecycle-messages": "static-1.58154",
  "commerce-products-lib": "static-1.9506",
  "crm-links": "static-1.6279",
  "customer-data-properties-shared-msw-handlers": "static-1.9266",
  "file-manager-components": "static-1.23592",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4216",
  "meetings-icalendar-utils-lib": "static-1.622",
  "object-builder-ui-client": "static-1.48705",
  "pipeline-validation-client-types": "static-1.3958",
  "property-value-citations": "static-1.2118",
  "smart-property-lib": "static-1.6913",
  "tiered-pricing": "static-1.1185",
  "ui-addon-iframeable": "static-1.9047",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19814",
  "tinymce-themes": "static-1.56306",
  "data-token-picker": "static-1.16391",
  "hub-http-contrib": "static-1.3033",
  "interframe": "static-3.4751",
  "tinymce-data": "static-1.40421",
  "tinymce-plugins": "static-1.57450",
  "ui-addon-sales-email": "static-1.5203",
  "magpie-lib": "static-1.5547",
  "magpie-types": "static-1.5007",
  "simple-logging-lib": "static-1.3040",
  "content-assistance-lib": "static-1.7736",
  "dashboard-lib": "static-1.81491",
  "ExportDialog": "static-6.10383",
  "hubspot-prosemirror": "static-1.18212",
  "hubspot-prosemirror-plugins": "static-1.18204",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8695",
  "campaign-roi-lib": "static-1.9073",
  "feedback-loader": "static-1.29278",
  "apollo-link-hub-http": "static-2.4641",
  "hubspot-apollo-cache": "static-1.328",
  "purchase-motions-api": "static-1.5866",
  "trials-service-types": "static-1.3895",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.164",
  "markdown-it": "static-1.6",
  "bend-plugin-pulse": "static-1.67",
  "directed-graph": "static-1.925",
  "event-emitter": "static-1.939",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1941",
  "growth-onboarding-next-action-components": "static-1.1920",
  "user-context-client": "static-1.4603",
  "idb-keyval": "static-1.43",
  "nest": "static-1.217",
  "reactive-lib": "static-1.715",
  "unified-auth-core-lib": "static-1.762",
  "getting-started-shared-tasks-store": "static-1.17583",
  "integrations-error-boundary-lib": "static-1.13507",
  "integrations-tracking-lib": "static-1.5591",
  "native-integrations-shared-strings": "static-1.7774",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10359",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.480",
  "calling-error-reporting": "static-1.31299",
  "shared-worker-versioning": "static-1.11028",
  "calling-usage-tracker": "static-1.6532",
  "voice-sms-access-library": "static-1.940",
  "customer-data-tracking": "static-1.6879",
  "commerce-permissions": "static-1.760",
  "products-iframe-lib": "static-1.7901",
  "products-ui-components-shared-msw-handlers": "static-1.10321",
  "location-customization-utils-lib": "static-1.9222",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4145",
  "video-components-external": "static-1.11230",
  "video-data-lib": "static-1.34888",
  "data-agent-kit": "static-1.179",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10022",
  "fsm": "static-1.3723",
  "policy-lib": "static-1.6771",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10085",
  "navigation-messaging": "static-1.7325",
  "FileManagerLib": "static-1.39232",
  "NamespacedHubStyle": "static-2.9052",
  "FileManagerCore": "static-1.39091",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12428",
  "layout-dnd-utils": "static-1.11403",
  "react-codemirror": "static-1.10617",
  "ui-addon-emoji-picker": "static-1.9880",
  "ui-brand-identity-lib": "static-1.15237",
  "ui-addon-video-player": "static-1.8694",
  "ui-coaching-tips": "static-1.28522",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23501",
  "EmailSignatureEditor": "static-1.24342",
  "breeze-engine-lib": "static-1.589",
  "InboxConnectUtils": "static-4.14780",
  "universal-page-editor-lib": "static-1.3005",
  "google-sheets-integration-lib": "static-1.204",
  "microsoft-drive-integration-lib": "static-1.324",
  "calling-orchestration-schema": "static-1.35717",
  "sales-views-client-types": "static-1.4251",
  "crm-record-cards-service-types": "static-1.3590",
  "content-media-composition-data-lib": "static-1.12226",
  "content-media-compositions": "static-2.16233",
  "media-bridge-lib": "static-1.18909",
  "trellis-story-utils": "static-1.4508",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5901",
  "FileManagerImages": "static-1.36743",
  "video-components": "static-1.13233",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4528",
  "video-embed": "static-1.35722",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68401",
  "layout-data-lib": "static-1.9728",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6572",
  "commerce-tours-lib": "static-1.6071",
  "growth-onboarding-reliability": "static-1.5072",
  "sales-checkout-service-client": "static-1.3632",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21659",
  "sales-email-signature-service-client": "static-1.3834",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22064",
  "outpost": "static-1.4175",
  "advanced-menus-core": "static-1.15111",
  "advanced-menus-lib": "static-1.12054",
  "ui-memberships-settings-lib": "static-1.34016",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15110",
  "simple-menus-lib": "static-1.16627"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34476",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34481",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2125",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5584",
  "hs-test-utils": "/hs-test-utils/static-1.8005",
  "hub-http": "/hub-http/static-1.6214",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11460",
  "I18n": "/I18n/static-7.1622",
  "jasmine-immutable": "/jasmine-immutable/static-1.3013",
  "jasmine-runner": "/jasmine-runner/static-1.6458",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.7020",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16659",
  "reporting-data": "/reporting-data/static-1.67502",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9435",
  "reporting-visualizations": "/reporting-visualizations/static-1.59578",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4755",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5062",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2489",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.788",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39726",
  "customer-data-objects": "/customer-data-objects/static-1.7658",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8080",
  "data-fetching-client": "/data-fetching-client/static-1.9662",
  "enviro": "/enviro/static-4.446",
  "FireAlarmUi": "/FireAlarmUi/static-1.4505",
  "flux-actions": "/flux-actions/static-1.337",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85815",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4709",
  "foundations-components": "/foundations-components/static-1.7914",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11767",
  "icons": "/icons/static-2.646",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7149",
  "metrics-js": "/metrics-js/static-1.9619",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "property-description-translator": "/property-description-translator/static-1.3836",
  "property-translator": "/property-translator/static-1.5391",
  "quartz-config": "/quartz-config/static-1.798",
  "quartz-core": "/quartz-core/static-1.6239",
  "quick-fetch": "/quick-fetch/static-1.3909",
  "raven": "/raven/static-3.5907",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5337",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8159",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8085",
  "report-customization-components": "/report-customization-components/static-1.13127",
  "reporting-enablement": "/reporting-enablement/static-1.22885",
  "reporting-reports": "/reporting-reports/static-1.67180",
  "reporting-snowflake": "/reporting-snowflake/static-1.56120",
  "reporting-ui-components": "/reporting-ui-components/static-2.64773",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4641",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8934",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9224",
  "sanitize": "/sanitize/static-1.4468",
  "sanitize-text": "/sanitize-text/static-1.8132",
  "self-service-api": "/self-service-api/static-1.10239",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1740",
  "signup-constants": "/signup-constants/static-1.18818",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20828",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8038",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4754",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10984",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11142",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9535",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17969",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11009",
  "ui-images": "/ui-images/static-2.1151",
  "UIComponents": "/UIComponents/static-3.8406",
  "usage-tracker": "/usage-tracker/static-1.7334",
  "usage-tracker-container": "/usage-tracker-container/static-1.7324",
  "usage-tracker-core": "/usage-tracker-core/static-1.7184",
  "usage-tracker-public": "/usage-tracker-public/static-1.7145",
  "viral-links-lib": "/viral-links-lib/static-1.7052",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3392",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3297",
  "quartz-webpack": "/quartz-webpack/static-1.3244",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8924",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4856",
  "foundations-theming": "/foundations-theming/static-1.4409",
  "quartz-auth": "/quartz-auth/static-1.695",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9041",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5020",
  "foundations-theming-base": "/foundations-theming-base/static-1.3394",
  "HeadJS": "/HeadJS/static-2.758",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3116",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.74",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4319",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.685",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7921",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3578",
  "persist-promise": "/persist-promise/static-1.3689",
  "quartz-i18n": "/quartz-i18n/static-1.695",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.939",
  "hs-story-utils": "/hs-story-utils/static-1.9418",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9939",
  "hubspotter-http": "/hubspotter-http/static-1.4644",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.208",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7238",
  "crm-message-bus": "/crm-message-bus/static-1.42958",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22161",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13017",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13153",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9817",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3997",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6779",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6874",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3839",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.971",
  "onboarding-tours": "/onboarding-tours/static-1.16575",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13649",
  "ui-addon-teams": "/ui-addon-teams/static-1.21529",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68326",
  "customer-data-properties": "/customer-data-properties/static-1.51504",
  "forms-ai-lib": "/forms-ai-lib/static-1.4304",
  "forms-utils-lib": "/forms-utils-lib/static-1.12559",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5397",
  "react-dnd-compat": "/react-dnd-compat/static-1.4608",
  "react-tinymce": "/react-tinymce/static-1.55210",
  "tinymce-config": "/tinymce-config/static-2.54336",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10340",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4183",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.20",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1887",
  "ui-fonts": "/ui-fonts/static-1.722",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.831",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.533",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.450",
  "quartz-test": "/quartz-test/static-1.695",
  "quartz-tracking": "/quartz-tracking/static-1.399",
  "batch-promise": "/batch-promise/static-1.1532",
  "external-options-client-types": "/external-options-client-types/static-1.4151",
  "react-colorpicker": "/react-colorpicker/static-2.10200",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4247",
  "copilot-toolkit": "/copilot-toolkit/static-1.11106",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12991",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6452",
  "reporting-action-components": "/reporting-action-components/static-1.41270",
  "reporting-filters": "/reporting-filters/static-1.295",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1716",
  "reporting-plugins": "/reporting-plugins/static-1.10308",
  "ui-addon-opt": "/ui-addon-opt/static-4.8360",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25347",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4869",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.51",
  "chirp-fetch": "/chirp-fetch/static-1.1878",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4162",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5863",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4073",
  "nested-table": "/nested-table/static-1.217",
  "timezone-utils": "/timezone-utils/static-2.5235",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "chatspot-core": "/chatspot-core/static-1.21246",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2892",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9937",
  "hs-resources": "/hs-resources/static-1.147",
  "pulse": "/pulse/static-1.564",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.858",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3790",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4130",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3684",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18465",
  "growth-data-modal": "/growth-data-modal/static-1.5414",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3058",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1892",
  "navigation-components": "/navigation-components/static-1.17998",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4789",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.641",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10152",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7533",
  "ui-universal-auth": "/ui-universal-auth/static-1.8966",
  "user-context": "/user-context/static-1.5095",
  "cms-field-types": "/cms-field-types/static-1.4802",
  "content-icons-ui": "/content-icons-ui/static-1.2223",
  "integrations-lib": "/integrations-lib/static-1.16092",
  "calling-global-api": "/calling-global-api/static-1.64478",
  "calling-internal-common": "/calling-internal-common/static-1.31292",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65860",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58154",
  "commerce-products-lib": "/commerce-products-lib/static-1.9506",
  "crm-links": "/crm-links/static-1.6279",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9266",
  "file-manager-components": "/file-manager-components/static-1.23592",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4216",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.622",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48705",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3958",
  "property-value-citations": "/property-value-citations/static-1.2118",
  "smart-property-lib": "/smart-property-lib/static-1.6913",
  "tiered-pricing": "/tiered-pricing/static-1.1185",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9047",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19814",
  "tinymce-themes": "/tinymce-themes/static-1.56306",
  "data-token-picker": "/data-token-picker/static-1.16391",
  "hub-http-contrib": "/hub-http-contrib/static-1.3033",
  "interframe": "/interframe/static-3.4751",
  "tinymce-data": "/tinymce-data/static-1.40421",
  "tinymce-plugins": "/tinymce-plugins/static-1.57450",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5203",
  "magpie-lib": "/magpie-lib/static-1.5547",
  "magpie-types": "/magpie-types/static-1.5007",
  "simple-logging-lib": "/simple-logging-lib/static-1.3040",
  "content-assistance-lib": "/content-assistance-lib/static-1.7736",
  "dashboard-lib": "/dashboard-lib/static-1.81491",
  "ExportDialog": "/ExportDialog/static-6.10383",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18212",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18204",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8695",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9073",
  "feedback-loader": "/feedback-loader/static-1.29278",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4641",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.328",
  "purchase-motions-api": "/purchase-motions-api/static-1.5866",
  "trials-service-types": "/trials-service-types/static-1.3895",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.164",
  "markdown-it": "/markdown-it/static-1.6",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.67",
  "directed-graph": "/directed-graph/static-1.925",
  "event-emitter": "/event-emitter/static-1.939",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1941",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1920",
  "user-context-client": "/user-context-client/static-1.4603",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.217",
  "reactive-lib": "/reactive-lib/static-1.715",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.762",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17583",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13507",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5591",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7774",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10359",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.480",
  "calling-error-reporting": "/calling-error-reporting/static-1.31299",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11028",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6532",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.940",
  "customer-data-tracking": "/customer-data-tracking/static-1.6879",
  "commerce-permissions": "/commerce-permissions/static-1.760",
  "products-iframe-lib": "/products-iframe-lib/static-1.7901",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10321",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9222",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4145",
  "video-components-external": "/video-components-external/static-1.11230",
  "video-data-lib": "/video-data-lib/static-1.34888",
  "data-agent-kit": "/data-agent-kit/static-1.179",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10022",
  "fsm": "/fsm/static-1.3723",
  "policy-lib": "/policy-lib/static-1.6771",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10085",
  "navigation-messaging": "/navigation-messaging/static-1.7325",
  "FileManagerLib": "/FileManagerLib/static-1.39232",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9052",
  "FileManagerCore": "/FileManagerCore/static-1.39091",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12428",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11403",
  "react-codemirror": "/react-codemirror/static-1.10617",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9880",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15237",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8694",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28522",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23501",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24342",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.589",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14780",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3005",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.204",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.324",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35717",
  "sales-views-client-types": "/sales-views-client-types/static-1.4251",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3590",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12226",
  "content-media-compositions": "/content-media-compositions/static-2.16233",
  "media-bridge-lib": "/media-bridge-lib/static-1.18909",
  "trellis-story-utils": "/trellis-story-utils/static-1.4508",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5901",
  "FileManagerImages": "/FileManagerImages/static-1.36743",
  "video-components": "/video-components/static-1.13233",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4528",
  "video-embed": "/video-embed/static-1.35722",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68401",
  "layout-data-lib": "/layout-data-lib/static-1.9728",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6572",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6071",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5072",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3632",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21659",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3834",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22064",
  "outpost": "/outpost/static-1.4175",
  "advanced-menus-core": "/advanced-menus-core/static-1.15111",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12054",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34016",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15110",
  "simple-menus-lib": "/simple-menus-lib/static-1.16627"
}
};
